import { get } from 'lodash';
import { createSelector } from 'reselect';
import { isPublished } from '@wix/communities-blog-universal/dist/src/post-utils';
import { hasUnpublishedChanges } from '../services/post-utils';

export const getPostEditor = (state) => state.postEditor;
export const getPostEditorPost = createSelector(getPostEditor, (postEditor) => postEditor.post);
export const getPostEditorPostId = createSelector(getPostEditor, (postEditor) => get(postEditor, 'post._id'));
export const getPostEditorDraftKey = createSelector(getPostEditor, (postEditor) => postEditor.draftKey);
export const getPostEditorInitialDraftKey = createSelector(getPostEditor, (postEditor) => postEditor.initialDraftKey);
export const getPostEditorInitialPost = createSelector(getPostEditor, (postEditor) => postEditor.initialPost);
export const getIsEditingDraft = createSelector(getPostEditorInitialPost, (initialPost) =>
  Boolean(!isPublished(initialPost) && get(initialPost, '_id')),
);
export const getIsEditingPost = createSelector(getPostEditorInitialPost, (initialPost) => isPublished(initialPost));

export const getHasUnpublishedChanges = createSelector(getPostEditorPost, (post) => hasUnpublishedChanges(post));
